export type CandidateStatus = "in_process" | "accepted" | "rejected" | "on_hold";
export type CandidateFileType = "cv" | "task" | "other";

export interface CandidateFile {
  id: string;
  file_type: CandidateFileType;
  original_name: string;
  url: string;
  uploaded_by_name: string | null;
  uploaded_at: string;
}

export interface Candidate {
  id: string;
  first_name: string;
  last_name: string;
  position: string;
  candidate_phone: string;
  candidate_email: string;
  phone_contacted: boolean;
  process_leader: string | null;
  process_leader_name: string | null;
  task_sent_date: string | null;
  days_since_task_sent: number | null;
  task_received: boolean;
  task_feedback: string;
  interview_date: string | null;
  interview_participants: string[];
  interview_participants_names: { id: string; name: string }[];
  confirmation_email_sent: boolean;
  notes: string;
  availability_notes: string;
  status: CandidateStatus;
  status_display: string;
  branch: string | null;
  first_work_day: string | null;
  rate: string;
  hr_notified: boolean;
  job_posting_url: string;
  files: CandidateFile[];
  created_at: string;
  updated_at: string;
}

export interface CandidateSms {
  id: string;
  kind: "confirmation" | "reminder";
  kind_display: string;
  phone: string;
  message: string;
  is_automatic: boolean;
  sent_by_name: string | null;
  sent_at: string;
}

export interface CandidateSmsInfo {
  sms_enabled: boolean;
  messages: CandidateSms[];
  planned_reminder_at: string | null;
}

export interface CandidateCounts {
  total: number;
  in_process: number;
  accepted: number;
  rejected: number;
  on_hold: number;
}

export const STATUS_LABELS: Record<CandidateStatus, string> = {
  in_process: "W trakcie",
  accepted: "Przyjęty",
  rejected: "Odrzucony",
  on_hold: "Wstrzymany",
};

export const STATUS_COLORS: Record<CandidateStatus, "blue" | "green" | "red" | "yellow"> = {
  in_process: "blue",
  accepted: "green",
  rejected: "red",
  on_hold: "yellow",
};

export const FILE_TYPE_LABELS: Record<CandidateFileType, string> = {
  cv: "CV",
  task: "Zadanie",
  other: "Inne",
};
